import { clsx } from 'clsx'

import {
  ChatContainer,
  NoChatsContainer,
  NewChat,
} from '@tribeplatform/react-components/Messaging'

import { ErrorBoundary } from '../Error/ErrorBoundry.js'
import { ChatDetailsSidebar } from './ChatDetailsSidebar.js'
import { NoChatSelected } from './NoChatSelected.js'

interface Props {
  hasChats?: boolean
  newChat?: boolean
  chatOpen?: boolean
}

export const MainContent = ({ hasChats, newChat, chatOpen }: Props) => {
  const showChatContainer = hasChats && chatOpen
  const showNoChatSelected = hasChats && !chatOpen

  return (
    <ErrorBoundary>
      <main className="grow min-w-0 relative sm:flex h-full">
        {!hasChats && <NoChatsContainer newChat={newChat} />}

        {showChatContainer && (
          <div className="grow h-full overflow-hidden">
            {newChat ? (
              <NewChat className={clsx(hasChats && 'sm:rounded-s-none')} />
            ) : (
              <ChatContainer />
            )}
          </div>
        )}
        {showNoChatSelected && (
          <div
            className={clsx('h-full w-full', !chatOpen && 'hidden sm:block')}
          >
            {!chatOpen && <NoChatSelected />}
          </div>
        )}
        <ChatDetailsSidebar />
      </main>
    </ErrorBoundary>
  )
}
